module.exports = __webpack_public_path__ + "img/tf.a668e447.svg";